<template>
    <div class="vr_box">
        <div class="vr_navs">
            
            <draggable class="box_01" v-model="navs" @update="datadragEnd" :options="{animation:200}">
                <div @click="qhB(i)" :class="['nav-d',i==on?'chekond':'']" v-for="(item,i) in navs" :key="i">
                    场景{{i+1}} 
                    <span v-if="value.length>1" @click="deel(i)" class="closefnn">X</span>
                </div>
            </draggable>



            <!-- <el-radio-group class="vr_bo" v-model="on" size="small">
                <el-radio-button v-for="(el,index) in value" :key="index" :label="index">场景{{index+1}} <i v-if="value.length>1" @click="deel(index)" class="closefnn">X</i></el-radio-button>
            </el-radio-group> -->
            <el-button v-if="value.length<8" class="vr_bo" @click="addFn" size="small">+添加场景</el-button>
        </div>
        <div class="vr_imgUp">
            <div>
                <div>场景平面图   jpg/png，10M内</div>
                <upload-image-new v-if="value[on]" v-model="value[on].main_pic_url" :config="up1"></upload-image-new>   
            </div>
            <div class="vr_imgUp1">
                <div>场景切换预览图   jpg/png，1M内</div>
                <upload-image-new v-if="value[on]" v-model="value[on].prev_url" :config="up2"></upload-image-new>   
            </div>    
        </div>

        <vr-com v-if="value[on]" v-model="value[on].sub_infos"></vr-com>
    </div>
  
</template>
<script>
import draggable from 'vuedraggable'
import uploadImageNew from "@/components/uploadImageNew.vue"
import vrCom from "./vrCom.vue"
export default {
    components: {
        draggable,
        uploadImageNew,
        vrCom
    },
    props:{
        value:Array
    },

    data() {
        return{
            up1:{
                type:['image/png','image/jpeg'],
                size:10,             
            },
            up2:{
                type:['image/png','image/jpeg'],
                size:1,             
            },
            on:'0',
            imageUrl:'',
            imageUrl2:'',
            navs:[],
            
        }
    },
    watch:{
        value(){
            this.navs = this.value;
        }
    },
    created(){

        this.navs = this.value;
 
    },
    methods: {
        addFn(){   
            this.value.push({
            sub_infos:[
              {
                jump_type:'1',
                hd:{jump_type:'1'}
               
              }
            ]
          });
        },
        deel(on){
            this.on = this.on-1<=0?0:this.on-1;
            this.navs.splice(on,1);
            this.$emit('input',this.navs)
        },
        async datadragEnd(evt) {
            evt.preventDefault();
            
            this.$emit('input',this.navs)

            this.on = evt.newIndex;
        },
        qhB(on){
            this.on = on
        }
 
    },
};
</script>
<style lang='scss'>
.vr_box{
    box-sizing: border-box;
    position: relative;
    border: 1px solid #DCDFE6;
    padding: 40px 10px 10px;
    border-radius: 5px;
}
.vr_navs{
    position: absolute;
    top: 0;
    left: 0;
}
.vr_bo{
    display: inline-block;
    vertical-align: top;
}
.vr_imgUp>div{
    display: inline-block;
    vertical-align: top;
}
.vr_imgUp1{
    margin-left: 60px;
}
.closefnn{
    visibility: hidden;
    position: absolute;
    top: 2px;
    right: 6px;
    line-height: 13px;    
}
.nav-d:hover .closefnn{
    visibility: visible;
}
.nav-d{
    cursor: pointer;
    position: relative;
    display: inline-block;
    vertical-align: top;
    border: 1px solid #DCDFE6;
    width: 80px;
    height: 32px;
    line-height: 32px;
    padding: 0;
    text-align: center;
    font-size: 12px;
    border-radius: 0;
}
.nav-d:hover{
    color:#33B3FF
}
.chekond:hover{
    color: #FFFFFF;
}
.chekond{
    color: #FFFFFF;
    background-color: #33B3FF;
    border-color: #33B3FF;
}
.box_01{
    display: inline-block;
    vertical-align: top;
}
</style>